import { createSelector } from "reselect";
import { getResource, getResources } from "selectors/resources";

const getLanguages = state => getResources(state, "language");

const getClientLanguage = (state) => {
  /** @type Client */
  const client = getResource(state, "client");

  return client.language;
};

const getClientTranslatedLanguageCodes = (state) => {
  /** @type Client */
  const client = getResource(state, "client");

  return client.translatedLanguages;
};

const getMessages = (state, ownProps) => ownProps.message || ownProps.messages;

export const getLanguagesFromMessages = createSelector(
  [getLanguages, getClientLanguage, getClientTranslatedLanguageCodes, getMessages],
  (languages, clientLanguage, translatedLanguages, messages) => languages
    .filter(language => (
      // Filter out primary language
      language.code !== clientLanguage &&

      // Make sure the response is translated in this language (from settings)
      translatedLanguages.includes(language.code) &&

      // Check for language key in messages
      messages
        .keySeq()
        .toArray()
        .includes(language.code)
    ))
    .sort((a, b) => {
      if (a.englishName < b.englishName) {
        return -1;
      }

      if (a.englishName > b.englishName) {
        return 1;
      }

      return 0;
    })
);

export const getAvailableLanguages = createSelector(
  [getLanguages, getClientLanguage, getClientTranslatedLanguageCodes, getLanguagesFromMessages],
  (languages, clientLanguage, translatedLanguages, enabledLanguages) => (
    languages.filter(language => (
      language.code !== clientLanguage &&
      !enabledLanguages.includes(language) &&
      translatedLanguages
        .includes(language.code)
    ))
  )
);

export const getClientTranslatedLanguages = createSelector(
  getLanguages,
  getClientTranslatedLanguageCodes,
  (languages, languageCodes) => languageCodes
    .map(code => languages.find(l => l.code === code))
    .filter(language => Boolean(language))
);
